import { render, staticRenderFns } from "./IdlingDischargeComponent.vue?vue&type=template&id=31c646c4&scoped=true"
import script from "./IdlingDischargeComponent.js?vue&type=script&lang=js&external"
export * from "./IdlingDischargeComponent.js?vue&type=script&lang=js&external"
import style0 from "./IdlingDischargeComponent.vue?vue&type=style&index=0&id=31c646c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c646c4",
  null
  
)

export default component.exports